import React from 'react';
import PropTypes from 'prop-types';
import Text from '@/components/Typography/Text';

const HEADING_STYLES = {
  h1: {
    size: 'xxxl',
    weight: 'bold',
    marginBottom: 24,
  },
  h2: {
    size: 'xxl',
    weight: 'bold',
    marginBottom: 20,
  },
  h3: {
    size: 'xl',
    weight: 'bold',
    marginBottom: 16,
  },
  h4: {
    size: 'l',
    weight: 'medium',
    marginBottom: 16,
  },
  h5: {
    size: 'm',
    weight: 'medium',
    marginBottom: 12,
  },
  h6: {
    size: 'n',
    weight: 'medium',
    marginBottom: 12,
  },
};

export default function Heading({ 
  children,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  color = 'primary',
  style,
}) {
  const level = h1 ? 'h1' : h2 ? 'h2' : h3 ? 'h3' : h4 ? 'h4' : h5 ? 'h5' : h6 ? 'h6' : 'h1';
  const { size, weight, marginBottom } = HEADING_STYLES[level];

  return (
    <Text 
      size={size}
      weight={weight}
      color={color}
      style={[
        {
          marginBottom,
          // lineHeight: 1.2,
        },
        style,
      ]}
    >
      {children}
    </Text>
  );
}

Heading.propTypes = {
  children: PropTypes.node.isRequired,
  h1: PropTypes.bool,
  h2: PropTypes.bool,
  h3: PropTypes.bool,
  h4: PropTypes.bool,
  h5: PropTypes.bool,
  h6: PropTypes.bool,
  color: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'alt']),
  style: PropTypes.object,
};
